import PropTypes from "prop-types"

export const ActionPropType = PropTypes.shape({
  label: PropTypes.string,
  icon: PropTypes.string,
  iconStyle: PropTypes.string,
  role: PropTypes.oneOf(["view"]),
  onClickSingle: PropTypes.func,
  onClickBulk: PropTypes.func,
  href: PropTypes.func, // (row) => url - if present, action renders as link
  danger: PropTypes.bool,
  disabled: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  hidden: PropTypes.func,
  primary: PropTypes.bool,
  confirm: PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.func.isRequired,
    confirmLabel: PropTypes.string,
  }),
})

export const ColumnPropType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  sortKey: PropTypes.string,
  header: PropTypes.node.isRequired,
  render: PropTypes.func,
  cardRender: PropTypes.func,
  renderSubRow: PropTypes.func,
  sortable: PropTypes.bool,
  width: PropTypes.string,
  hide: PropTypes.bool,
  printHide: PropTypes.bool,
  headerAlign: PropTypes.oneOf(["left", "center", "right", "justify"]),
  cellAlign: PropTypes.oneOf(["left", "center", "right", "justify"]),
  cardRole: PropTypes.oneOf([
    "title",
    "subtitle",
    "detail",
    "badge",
    "hidden",
    "footer",
  ]),
  cardOrder: PropTypes.number,
})

export const SelectionPropType = PropTypes.arrayOf(
  PropTypes.oneOfType([PropTypes.string, PropTypes.number])
)

export const RowConfigPropType = PropTypes.shape({
  variant: PropTypes.func,
  color: PropTypes.func,
  textColor: PropTypes.func,
  innerRef: PropTypes.func,
  onClick: PropTypes.func,
  getViewUrl: PropTypes.func, // (row) => url — enables row-click navigation + auto-generates view action
  onViewClick: PropTypes.func, // (row, source) => void — called on navigation; source is "row" | "indicator" | "action"
})

export const SortConfigPropType = PropTypes.shape({
  sortKey: PropTypes.string,
  sortDirection: PropTypes.oneOf(["asc", "desc", "ASC", "DESC"]),
  onColumnSort: PropTypes.func, // Legacy: receives raw column key
  onSortChange: PropTypes.func, // New: receives { key, direction } with toggle handled internally
})

export const SearchConfigPropType = PropTypes.shape({
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  placeholder: PropTypes.string,
})
